import { render, staticRenderFns } from "./TalkMemoMsg.vue?vue&type=template&id=055e6f1a&scoped=true"
import script from "./TalkMemoMsg.vue?vue&type=script&lang=js"
export * from "./TalkMemoMsg.vue?vue&type=script&lang=js"
import style0 from "./TalkMemoMsg.vue?vue&type=style&index=0&id=055e6f1a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055e6f1a",
  null
  
)

export default component.exports